import { all, put, takeLatest } from 'redux-saga/effects';
import { GET_NOTIFICATIONS_BY_USER, MARK_NOTIFICATION_AS_READ } from './constants';
import Api from '../../commons/api';
import * as NotificationActions from './action';
import { resetUserState } from '../users/action';

const controller = 'notifications';

function* fetchNotificationsByUserId({ payload }) {
  try {
    const { userId } = payload;
    const { data } = yield Api.get(`${controller}/${controller}/user/${userId}`);
    yield put(NotificationActions.getNotificationsByUserSuccess(data));
  } catch (err) {
    if (err?.normalizedError?.status === 401) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      yield put(resetUserState());
      window.location.href = '/';
      return;
    }
    yield put(NotificationActions.getNotificationsByUserFailed(err));
  }
}

function* markNotificationAsRead({ payload }) {
  try {
    const { notificationId } = payload;
    const { data } = yield Api.put(`${controller}/${controller}/${notificationId}/read`);
    yield put(NotificationActions.markNotificationAsReadSuccess(data));
  } catch (err) {
    yield put(NotificationActions.markNotificationAsReadFailed(err));
  }
}

function* ActionWatcher() {
  yield takeLatest(GET_NOTIFICATIONS_BY_USER, fetchNotificationsByUserId);
  yield takeLatest(MARK_NOTIFICATION_AS_READ, markNotificationAsRead);
}

export default function* NotificationSaga() {
  yield all([ActionWatcher()]);
}
